import { render, staticRenderFns } from "./stock-box.vue?vue&type=template&id=aebe2496&"
import script from "./stock-box.vue?vue&type=script&lang=js&"
export * from "./stock-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports